<template>
<form
  aria-label="Claim a username"
  autocomplete="off"
  role="presentation"
  @submit.prevent="submit"
>
  <div class="control control_round">
    <span>{{host}}/</span>
    <input
      v-model="username"
      type="text"
      :placeholder="usernamePlaceholder"
      required
      :aria-label="`Choose a ${usernamePlaceholder}`"
      pattern="\w+"
    >
  </div>

  <button
    class="button-brand orange analytics-go-to-signup"
    type="submit"
  >
    Claim your page
  </button>
</form>
</template>

<script>
import { claimUsername } from '@/api/auth';
import userMessages from '@/mixins/user-messages';
import { trackZohoPageSenseEvent } from '@/utils/zoho';

export default {
  name: 'ClaimUsernameForm',
  mixins: [userMessages],
  data() {
    return {
      username: '',
    };
  },
  methods: {
    async submit() {
      try {
        const { data } = await claimUsername(this.username);
        trackZohoPageSenseEvent('homepage-claim-username');
        await this.$router.push({ name: 'SignUp', query: { usernameId: data.id } });
      } catch (e) {
        this.setErrorMessage(e);
      }
    },
  },
  computed: {
    host() {
      return window.location.host;
    },
    usernamePlaceholder() {
      // HACK: prevent to show Safari autofill
      return 'user\u200Bname';
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/mixins";

form {
  @include media-lg() {
    display: flex;
    align-items: stretch;
  }
}

.control {
  @include media-sm-only() {
    margin-bottom: 1rem;
  }

  @include media-lg() {
    flex-grow: 1;
    display: inline-flex;
    margin-right: 0.5rem;
  }
}

.button-brand {
  @include media-sm-only() {
    display: block;
    width: 100%;
  }
}
</style>
